
/* ===== v2 부팅 · 라우팅 (신규 화면 포함) ===== */
window.PIA_BOT = '<svg viewBox="0 0 200 220" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="예담 톡 캐릭터"><defs><linearGradient id="pbG" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#fff"/><stop offset="1" stop-color="#e8edf5"/></linearGradient></defs><ellipse cx="118" cy="150" rx="72" ry="58" fill="#dbe4ff" opacity=".55"/><path d="M100 34c0-8 6-14 14-14s14 6 14 14-6 14-14 20c-8-6-14-12-14-20z" fill="#256ef4"/><rect x="97" y="50" width="6" height="14" rx="3" fill="#256ef4"/><rect x="46" y="62" width="108" height="94" rx="44" fill="url(#pbG)" stroke="#c9cfd8" stroke-width="2"/><rect x="60" y="76" width="80" height="62" rx="31" fill="#1e2124"/><path d="M78 104q7-9 14 0" stroke="#fff" stroke-width="5" fill="none" stroke-linecap="round"/><path d="M108 104q7-9 14 0" stroke="#fff" stroke-width="5" fill="none" stroke-linecap="round"/><path d="M88 118q12 10 24 0" stroke="#fff" stroke-width="5" fill="none" stroke-linecap="round"/><rect x="30" y="88" width="18" height="40" rx="9" fill="#256ef4"/><rect x="152" y="88" width="18" height="40" rx="9" fill="#256ef4"/><rect x="66" y="160" width="68" height="46" rx="20" fill="#fff" stroke="#c9cfd8" stroke-width="2"/><rect x="72" y="168" width="56" height="12" rx="6" fill="#256ef4"/><circle cx="100" cy="192" r="12" fill="#256ef4"/><text x="100" y="196" font-size="9" font-weight="700" fill="#fff" text-anchor="middle" font-family="sans-serif">PIA</text><g transform="rotate(-22 42 150)"><rect x="30" y="140" width="16" height="44" rx="8" fill="#fff" stroke="#c9cfd8" stroke-width="2"/><circle cx="38" cy="138" r="11" fill="#fff" stroke="#c9cfd8" stroke-width="2"/></g><rect x="154" y="150" width="16" height="44" rx="8" fill="#fff" stroke="#c9cfd8" stroke-width="2"/></svg>';
(function(){
  var PIA=window.PIA;
  var NEW_VIEWS=['consent','setup','done','mindintro'];
  function boot(){
    try{
      document.body.classList.add('pia-v2');
      if(!document.querySelector('.pia-hdr')){
        var w=document.createElement('div'); w.innerHTML=PIA.header();
        document.body.insertBefore(w.firstChild, document.body.firstChild);
      }
      var hs=document.querySelector('section[data-view="home"]');
      if(hs){
        NEW_VIEWS.forEach(function(v){
          if(document.querySelector('section[data-view="'+v+'"]')) return;
          var s=document.createElement('section');
          s.setAttribute('data-view',v); s.id='pia-'+v+'-sec'; s.className='hidden';
          hs.parentNode.insertBefore(s, hs.nextSibling);
        });
      }
    }catch(e){ console.error('pia boot:',e); }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();

  function flush(){
    try{
      var p=window._piaHomePending;
      if(p){ var el2=document.getElementById('home-content');
        if(el2){ el2.innerHTML=window.piaRenderHomeV2(p.cards,p.isDone,p.reqDone); window._piaHomePending=null; } }
      else if(typeof renderHome==='function'){ renderHome(); }
    }catch(e){ console.error('pia flush:',e); }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ setTimeout(flush,60); });
  else setTimeout(flush,60);
  setTimeout(flush,400);

  var RENDER={
    consent:function(){ return window.piaRenderConsent(); },
    setup:function(){ return window.piaRenderSetup(); },
    done:function(){ return window.piaRenderDone(); },
    mindintro:function(){ return window.piaRenderMindIntro(window._piaMindTarget); }
  };
  var _o=showView;
  showView=function(n){
    _o(n);
    try{
      if(RENDER[n]){
        var s=document.getElementById('pia-'+n+'-sec');
        if(s){ s.innerHTML=RENDER[n](); s.classList.remove('hidden');
          if(n==='consent') setTimeout(window.piaConsentSync,50);
          if(n==='setup') setTimeout(function(){ var f=document.getElementById('sv-code'); if(f&&!f.value) f.focus(); },200);
        }
      }
      window.scrollTo(0,0);
      setTimeout(function(){ try{ PIA.autoRead(); }catch(e){} },380);
      if(n==='home') setTimeout(function(){ try{ PIA.greetOnce(); }catch(e){} },700);
    }catch(e){}
  };

  /* 필수 3종 완료 순간 → 완료 화면으로 안내 */
  window._piaCheckAllDone=function(){
    try{
      var b={}; (window._piaCards||[]).forEach(function(c){b[c.id]=c;});
      var all=['chat','big5','riasec'].every(function(i){ return b[i]&&window._piaIsDone(b[i]); });
      if(all && !sessionStorage.getItem('pia_done_shown')){
        sessionStorage.setItem('pia_done_shown','1');
        setTimeout(function(){ showView('done'); },400);
        return true;
      }
    }catch(e){}
    return false;
  };
})();


(function(){
  var _o=showView;
  showView=function(n){
    _o(n);
    try{ document.body.classList.toggle('pia-on-result', n==='result'); }catch(e){}
  };
  try{ document.body.classList.toggle('pia-on-result',
    (document.querySelector('section[data-view]:not(.hidden)')||{dataset:{}}).dataset.view==='result'); }catch(e){}
})();
